<template>
  <router-link tag="div"
               :to="{name:'lesson',params: {slug:lesson.slug}}"
               class="lesson-item bg-block">
    <div class="bg"></div>
    <div class="content">
      <span>{{ lesson.title }}</span>
      <div class="progress-bar" :style="{'width': lesson.progress+'%'}"></div>
      <span class="progress-title">{{ lesson.progress }}%</span>
    </div>

  </router-link>
</template>
<script>
export default {
  name: 'lessonItem',
  props: ["lesson"]
}
</script>

<style lang="scss" scoped>
.lesson-item {
  margin-bottom: 15px;
}

.content {


  .progress-bar {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    border-radius: 3px;
    background: $green;
    width: 50%;
  }

  .progress-title {
    opacity: 0;
    transition: opacity linear 300ms;
  }

  &:hover .progress-title {
    opacity: 1;
  }

}
</style>
